export const PRODUCT_IMAGES = {
  ecobag: "/legacy/whatsapp-image-2026-06-22-at-10.07.19-4-.jpeg",
  ecobagAlt: "/legacy/ecobag-04.png",
  ecobagCatalogo: "/legacy/ecobag-catalago-01.png",
  ecobagHome: "/legacy/salacola-home-pege.png",
  ecobagKitA: "/legacy/whatsapp-image-2026-06-22-at-10.07.20.jpeg",
  ecobagKitB: "/legacy/whatsapp-image-2026-06-22-at-10.07.20-1-.jpeg",
  ecobagKitC: "/legacy/whatsapp-image-2026-06-22-at-10.07.20-2-.jpeg",
  ecobagKitD: "/legacy/whatsapp-image-2026-06-22-at-10.07.20-3-.jpeg",
  tnt: "/legacy/cs-tnt-preta-01.png",
  tntBrancoAlca: "/legacy/tnt-branco-co-al-a-colorida-transfer-digitasl.jpeg",
  tntBrancoAlcaAlt: "/legacy/tnt-branco-al-a-colorida-transfer-digital.jpeg",
  tntVerde: "/legacy/sc-tnt-colorida-verde-lisa-33x40.jpeg",
  tntRosa: "/legacy/sc-tnt-colorida-rosa-33x40.jpeg",
  tntBrancoTransfer: "/legacy/sc-tnt-branco-transfer-digital.jpeg",
  squeeze: "/legacy/squeeze-garrafa-de-al-minio-01.png",
  toalha: "/legacy/toalha-de-m-o-01.png",
  mochilaCorporativa: "/generated/mochila-corporativa.jpg",

  // TNT — novas imagens (2026-07)
  tntNovoCapa: "/legacy/whatsapp-image-2026-07-14-at-17.03.43-1-.jpeg",
  tntNovo2: "/legacy/whatsapp-image-2026-07-14-at-17.03.43.jpeg",
  tntNovo3: "/legacy/whatsapp-image-2026-07-14-at-17.03.42.jpeg",
  tntNovo4: "/legacy/whatsapp-image-2026-07-14-at-17.03.43-2-.jpeg",

  // Toalha Social Slim — variantes coloridas
  socialSlimRosa: "/legacy/whatsapp-image-2026-07-13-at-11.40.48.jpeg",
  socialSlimAzul: "/legacy/whatsapp-image-2026-07-13-at-11.40.47-3-.jpeg",
  socialSlimVermelha: "/legacy/whatsapp-image-2026-07-13-at-11.40.49-2-.jpeg",
  socialSlimAmarela: "/legacy/whatsapp-image-2026-07-13-at-11.40.49-3-.jpeg",

  // Toalha Fitness Slim — variantes coloridas
  fitnessSlimRosa: "/legacy/whatsapp-image-2026-07-13-at-11.40.49.jpeg",
  fitnessSlimAzul: "/legacy/whatsapp-image-2026-07-13-at-11.40.49-1-.jpeg",

  // Caderno estilo Moleskine — novas imagens
  cadernoCapa: "/legacy/whatsapp-image-2026-07-13-at-11.40.47-1-.jpeg",
  cadernoTurquesa: "/legacy/caderno-21x14-cm-azul-vclaro.png",
  cadernoVermelho: "/legacy/whatsapp-image-2026-07-13-at-11.40.47.jpeg",
  cadernoLaranja: "/legacy/whatsapp-image-2026-07-13-at-11.40.46-3-.jpeg",

  // Chapéu Estilo Panamá — novas imagens
  chapeuBege: "/legacy/whatsapp-image-2026-07-13-at-11.40.44.jpeg",
  chapeuOffWhite: "/legacy/whatsapp-image-2026-07-13-at-11.40.45-1-.jpeg",
  chapeuMarrom: "/legacy/whatsapp-image-2026-07-13-at-11.40.43.jpeg",
  chapeuBranco: "/legacy/whatsapp-image-2026-07-13-at-11.40.46.jpeg",

  // Camiseta de Algodão Gola Careca
  camisetaCapa: "/legacy/whatsapp-image-2026-07-14-at-16.58.14.jpeg",
  camisetaCinza: "/legacy/whatsapp-image-2026-07-14-at-16.58.14-1-.jpeg",
  camisetaPreta: "/legacy/whatsapp-image-2026-07-14-at-16.58.15.jpeg",
  camisetaAzulMarinho: "/legacy/whatsapp-image-2026-07-14-at-16.58.15-1-.jpeg",
  camisetaAzulRoyal: "/legacy/whatsapp-image-2026-07-14-at-16.58.15-2-.jpeg",

  // Toalhas — capas corretas (2026-07-15) — foto rotulada pelo cliente
  socialSlimCapaCorreta: "/legacy/whatsapp-image-2026-07-13-at-11.40.48-3--2.jpeg",
  fitnessSlimCapaCorreta: "/legacy/whatsapp-image-2026-07-13-at-11.40.48-1--2.jpeg",

  // Sacola Tipo Mochila Ecológica
  mochilaEcoAlgodao: "/legacy/whatsapp-image-2026-07-15-at-11.13.30-1-.jpeg",
  mochilaEcoMicrofibra: "/legacy/whatsapp-image-2026-07-15-at-11.13.31.jpeg",
  mochilaEcoMicrofibraAstra: "/legacy/chatgpt-image-15-de-jul.-de-2026-11_20_07.png",

  // Saquinho Algodão Cru
  saquinhoAlgodao: "/legacy/whatsapp-image-2026-07-15-at-11.13.31-2-.jpeg",
  saquinhoAlgodao2: "/legacy/whatsapp-image-2026-07-15-at-11.13.31-1-.jpeg",

  // Caneca / DTF / Transfer — geradas via Nano Banana
  canecaPersonalizada: "/generated/caneca-personalizada.jpg",
  canecaPreta: "/generated/caneca-preta.jpg",
  canecaAzul: "/generated/caneca-azul.jpg",
  canecaVermelha: "/generated/caneca-vermelha.jpg",
  dtfTextil: "/generated/dtf-textil.jpg",
  dtfMoletom: "/generated/dtf-moletom.jpg",
  dtfBone: "/generated/dtf-boneCap.jpg",
  dtfSacola: "/generated/dtf-sacola.jpg",
  transferDigital: "/generated/transfer-digital.jpg",
  transferCamiseta: "/generated/transfer-camiseta.jpg",
  transferFilm: "/generated/transfer-film-close.jpg",
  transferMulti: "/generated/transfer-multi.jpg",

  // Camiseta Polo Masculina (2026-07-20)
  poloPreta: "/legacy/66158fb484ccee3b72977bf0fff3e7922cc03358ae5994b2f4400097d6fbaf8a.png",
  poloBranca: "/legacy/e29ffda481d5605559cdb4b0bdfb972932cd3f8ec1c0e20a91d879faaee1562c.png",
  poloAzulMarinho: "/legacy/file_00000000d1d8820ea83f75224f94a99a.png",

  // Porta Copo em Couro Sintético Ecológico (2026-07-20)
  portaCopoMnaief: "/legacy/file_000000008350820e948dfde08814557e.png",
  portaCopoNexway: "/legacy/file_000000004758820e967ac477e0b65020.png",
};

export const PRODUCTS = [
  {
    slug: "ecobag-algodao",
    name: "Sacola de Algodão",
    short: "Personalizada",
    tagline: "Sustentável e prática — sua marca andando junto com o cliente.",
    description:
      "Tecido 100% algodão cru, alta gramatura e ótimo acabamento. Ideal para empresas que querem mais visibilidade e uma escolha sustentável.",
    benefits: [
      "Algodão 100% natural",
      "Personalização em Silk Screen, Transfer Digital ou DTF",
      "Alças reforçadas",
      "Uso duradouro e reutilizável",
    ],
    specs: {
      Material: "Algodão cru 160g/m²",
      Tamanhos: "30 × 40 cm / 38 × 42 cm",
      Personalização: "Silk Screen, Transfer Digital, DTF",
      "Pedido mínimo": "50 unidades",
      Prazo: "7 a 12 dias úteis",
    },
    badge: "Mais procurada",
    image: PRODUCT_IMAGES.ecobag,
    gallery: [
      {
        src: "/legacy/sc-com-uma-empress-o-digital.png",
        label: "RM Idiomas — Transfer digital 20×30 cm",
      },
      {
        src: "/legacy/bolsa-ecol-gica-para-a-sustentabilidade-2026.png",
        label: "Sustainability Week 2026 — Transfer digital 28×30 / 30×30 cm",
      },
      {
        src: "/legacy/chatgpt-image-26_06_2026-07_43_56.png",
        label: "BRAZ TESOL 40 — Transfer digital 28×40 / 30×40 cm",
      },
      {
        src: "/legacy/whatsapp-image-2026-06-24-at-17.07.46-2-.jpeg",
        label: "EuroChem — Transfer digital 38×40 / 40×40 cm",
      },
      {
        src: "/legacy/whatsapp-image-2026-06-24-at-17.07.40-1-.jpeg",
        label: "PicPay — Transfer digital 38×40 / 40×40 cm",
      },
    ],
  },
  {
    slug: "sacola-tnt",
    name: "Sacola TNT",
    short: "Personalizada",
    tagline: "Versatilidade e impacto visual para eventos corporativos.",
    description:
      "Sacolas TNT em diversas cores e tamanhos, com acabamento profissional. Perfeitas para feiras, congressos, lançamentos e kits corporativos.",
    benefits: [
      "TNT 80g/m² ou 100g/m²",
      "Diversas cores disponíveis",
      "Personalização em Silk Screen, Transfer Digital e DTF",
      "Excelente custo-benefício",
    ],
    specs: {
      Material: "TNT 80g/m² ou 100g/m²",
      Cores: "Preto, branco, vermelho, azul, dourado, entre outras",
      Personalização: "Silk Screen, Transfer Digital, DTF",
      "Pedido mínimo": "100 unidades",
      Prazo: "5 a 10 dias úteis",
    },
    badge: "Custo-benefício",
    image: PRODUCT_IMAGES.tntNovoCapa,
    gallery: [
      { src: PRODUCT_IMAGES.tntNovo2, label: "SESC / CNC SENAC — Transfer Digital" },
      { src: PRODUCT_IMAGES.tntNovo3, label: "AAPREV — III Congresso Brasileiro de Direito Previdenciário" },
      { src: PRODUCT_IMAGES.tntNovo4, label: "PDJ — Programa de Desenvolvimento Jurema" },
    ],
  },
  {
    slug: "squeeze",
    name: "Squeeze de Alumínio",
    short: "Personalizado",
    tagline: "Hidratação no dia a dia com a sua marca em destaque.",
    description:
      "Squeezes de alumínio leve e resistente, com mosquetão e acabamento fosco. Ótima lembrança para eventos, ações de endomarketing e onboarding.",
    benefits: [
      "Alumínio leve e resistente",
      "Capacidade 500 a 750 ml",
      "Gravação a laser ou silk",
      "Tampa com mosquetão",
    ],
    specs: {
      Material: "Alumínio com pintura fosca",
      Capacidade: "500 ml / 750 ml",
      Personalização: "Gravação a laser ou silk-screen",
      "Pedido mínimo": "50 unidades",
      Prazo: "8 a 14 dias úteis",
    },
    badge: "Mais pedido",
    image: PRODUCT_IMAGES.squeeze,
  },
  {
    slug: "toalha-personalizada",
    name: "Toalha de Mão",
    short: "Personalizada",
    tagline: "Maciez e qualidade em algodão de alta gramatura.",
    description:
      "Toalhas em algodão de qualidade com bordado ou estampa exclusiva. Brinde diferenciado para hotelaria, academias, clínicas e ações especiais.",
    benefits: [
      "Algodão 380 a 450 g/m²",
      "Bordado computadorizado",
      "Bainhas reforçadas",
      "Acabamento de luxo",
    ],
    specs: {
      Material: "Algodão 380 a 450 g/m²",
      Tamanhos: "30 × 50 cm / 40 × 70 cm",
      Personalização: "Bordado, estampa ou jacquard",
      "Pedido mínimo": "50 unidades",
      Prazo: "10 a 15 dias úteis",
    },
    badge: "Diferenciado",
    image: PRODUCT_IMAGES.toalha,
  },
  {
    slug: "toalha-social-slim",
    name: "Toalha Social Slim",
    short: "23 × 36 cm",
    tagline: "Elegância compacta para hospitalidade e eventos executivos.",
    description:
      "Toalha social slim em algodão 100%, formato compacto 23×36 cm. Ideal para restaurantes, hotéis, kits de banheiro corporativo e experiências premium com Silk Screen, Transfer Digital e DTF.",
    benefits: [
      "Algodão 100%, toque macio",
      "Formato slim 23×36 cm",
      "Personalização com Silk Screen, Transfer Digital e DTF",
      "Ótimo caimento e absorção",
    ],
    specs: {
      Material: "Algodão 100%",
      Tamanho: "23 × 36 cm",
      Personalização: "Silk Screen, Transfer Digital, DTF",
      "Pedido mínimo": "50 unidades",
      Prazo: "10 a 15 dias úteis",
    },
    badge: "Hospitalidade",
    image: PRODUCT_IMAGES.socialSlimCapaCorreta,
    gallery: [
      { src: PRODUCT_IMAGES.socialSlimRosa, label: "Rosa — Toalha Social Slim 23×36 cm" },
      { src: PRODUCT_IMAGES.socialSlimAzul, label: "Azul Royal — Toalha Social Slim 23×36 cm" },
      { src: PRODUCT_IMAGES.socialSlimVermelha, label: "Vermelha — Toalha Social Slim 23×36 cm" },
      { src: PRODUCT_IMAGES.socialSlimAmarela, label: "Amarela — Toalha Social Slim 23×36 cm" },
    ],
  },
  {
    slug: "toalha-fitness-slim",
    name: "Toalha Fitness Slim",
    short: "29 × 70 cm",
    tagline: "Alta absorção e formato prático para academias e kits fitness.",
    description:
      "Toalha fitness slim em algodão 100% de alta absorção, formato 29×70 cm otimizado para academia, ciclismo, corrida e clubes esportivos. Personalização por Silk Screen, Transfer Digital e DTF.",
    benefits: [
      "Algodão 100%, alta absorção",
      "Formato slim 29×70 cm",
      "Ideal para academias, clubes e eventos esportivos",
      "Personalização por Silk Screen, Transfer Digital e DTF",
    ],
    specs: {
      Material: "Algodão 100%",
      Tamanho: "29 × 70 cm",
      Personalização: "Silk Screen, Transfer Digital, DTF",
      "Pedido mínimo": "50 unidades",
      Prazo: "10 a 15 dias úteis",
    },
    badge: "Fitness",
    image: PRODUCT_IMAGES.fitnessSlimCapaCorreta,
    gallery: [
      { src: PRODUCT_IMAGES.fitnessSlimRosa, label: "Rosa — Toalha Fitness Slim 29×70 cm" },
      { src: PRODUCT_IMAGES.fitnessSlimAzul, label: "Azul Royal — Toalha Fitness Slim 29×70 cm" },
    ],
  },
  {
    slug: "caderno-moleskine",
    name: "Caderno Moleskine",
    short: "Personalizado",
    tagline: "Papelaria premium para brindes executivos e onboarding.",
    description:
      "Caderno Moleskine em capa dura. Elástico e marcador de página, miolo pautado com 80 folhas em papel offset 90g. Personalização por gravação a laser ou hot stamping dourado.",
    benefits: [
      "Capa dura colorida de toque suave",
      "Elástico e marcador de página",
      "Miolo pautado 80 folhas — 90 g/m²",
      "Gravação a laser ou hot stamping dourado",
    ],
    specs: {
      Material: "Capa dura sintética + miolo offset 90g",
      Tamanho: "14 × 21 cm (A5)",
      Cores: "Colorido",
      Personalização: "Laser, hot stamping ou silk-screen",
      "Pedido mínimo": "50 unidades",
      Prazo: "10 a 15 dias úteis",
    },
    badge: "Executivo",
    image: PRODUCT_IMAGES.cadernoCapa,
    gallery: [
      { src: PRODUCT_IMAGES.cadernoTurquesa, label: "Azul turquesa — Caderno Moleskine 14×21 cm" },
      { src: PRODUCT_IMAGES.cadernoVermelho, label: "Vermelho — Caderno Moleskine 14×21 cm" },
      { src: PRODUCT_IMAGES.cadernoLaranja, label: "Laranja — Caderno Moleskine 14×21 cm" },
    ],
  },
  {
    slug: "chapeu-panama",
    name: "Chapéu Estilo Panamá",
    short: "Personalizado",
    tagline: "Sofisticação atemporal para eventos, brindes VIP e presentes de marca.",
    description:
      "Chapéu estilo Panamá com acabamento que remete à palha natural, fita grosgrain preta clássica. Elegante e versátil, ideal para eventos, campanhas de verão, brindes VIP e ações de marca lifestyle.",
    benefits: [
      "Acabamento que remete à palha natural — cor creme",
      "Fita grosgrain preta clássica",
      "Aba média — visual atemporal",
      "Bordado ou etiqueta personalizada",
    ],
    specs: {
      Material: "Acabamento que remete à palha natural + fita grosgrain",
      Tamanhos: "P / M / G / GG",
      Cores: "Bege, off-white, marrom e branco",
      Personalização: "Etiqueta bordada ou bordado direto",
      "Pedido mínimo": "50 unidades",
      Prazo: "12 a 18 dias úteis",
    },
    badge: "Lifestyle",
    image: PRODUCT_IMAGES.chapeuBege,
    gallery: [
      { src: PRODUCT_IMAGES.chapeuOffWhite, label: "Off-white — Chapéu Estilo Panamá" },
      { src: PRODUCT_IMAGES.chapeuMarrom, label: "Marrom — Chapéu Estilo Panamá" },
      { src: PRODUCT_IMAGES.chapeuBranco, label: "Branco — Chapéu Estilo Panamá" },
    ],
  },
  {
    slug: "mochila-corporativa",
    name: "Mochila Corporativa",
    short: "Personalizada",
    tagline: "Design executivo com compartimento acolchoado para notebook.",
    description:
      "Mochila corporativa em poliéster premium preto matte, com compartimento acolchoado para notebook até 15,6\", bolso frontal e alças ergonômicas. Personalização por bordado, silk-screen ou etiqueta de couro sintético.",
    benefits: [
      "Poliéster resistente à água",
      "Compartimento acolchoado para notebook 15,6\"",
      "Alças acolchoadas ergonômicas",
      "Bordado, silk-screen ou etiqueta em couro",
    ],
    specs: {
      Material: "Poliéster 600D + forro interno",
      Dimensões: "44 × 30 × 15 cm",
      Personalização: "Bordado, silk-screen ou etiqueta",
      "Pedido mínimo": "50 unidades",
      Prazo: "12 a 18 dias úteis",
    },
    badge: "Executiva",
    image: PRODUCT_IMAGES.mochilaCorporativa,
  },
  {
    slug: "camiseta-algodao-gola-careca",
    name: "Camiseta de Algodão Gola Careca",
    short: "Personalizada",
    tagline: "Conforto premium em algodão puro — a base ideal para uniformes e brindes de marca.",
    description:
      "Camiseta em algodão penteado de gola careca, corte reto e acabamento premium. Ideal para uniformes corporativos, eventos, kits de boas-vindas e ações promocionais. Personalização por Silk Screen, Transfer Digital e DTF.",
    benefits: [
      "Algodão penteado 30.1 — toque macio",
      "Gola careca reforçada — não deforma",
      "Corte reto unissex",
      "Personalização por Silk Screen, Transfer Digital e DTF",
    ],
    specs: {
      Material: "Algodão penteado 30.1 (100% algodão)",
      Tamanhos: "PP / P / M / G / GG / XG",
      Cores: "Branca, cinza, preta, azul marinho, azul royal e sob consulta",
      Personalização: "Silk Screen, Transfer Digital, DTF",
      "Pedido mínimo": "50 unidades",
      Prazo: "10 a 15 dias úteis",
    },
    badge: "Novidade",
    image: PRODUCT_IMAGES.camisetaCapa,
    gallery: [
      { src: PRODUCT_IMAGES.camisetaCinza, label: "Cinza — Camiseta de Algodão Gola Careca" },
      { src: PRODUCT_IMAGES.camisetaPreta, label: "Preta — Camiseta de Algodão Gola Careca" },
      { src: PRODUCT_IMAGES.camisetaAzulMarinho, label: "Azul Marinho — Camiseta de Algodão Gola Careca" },
      { src: PRODUCT_IMAGES.camisetaAzulRoyal, label: "Azul Royal — Camiseta de Algodão Gola Careca" },
    ],
  },
  {
    slug: "sacola-mochila-ecologica",
    name: "Sacola Tipo Mochila Ecológica",
    short: "Personalizada",
    tagline: "Praticidade e sustentabilidade em um design moderno de mochila-saco.",
    description:
      "Sacola tipo mochila ecológica em Algodão Cru cor bege clara, com fechamento em cordão e alças no formato mochila. Opção adicional em microfibra impermeável. Excelente para eventos esportivos, kits corporativos, congressos e ações institucionais.",
    benefits: [
      "Algodão cru bege claro 100% natural",
      "Alças em cordão que viram mochila",
      "Opção adicional em microfibra impermeável",
      "Personalização por Silk Screen, Transfer Digital e DTF",
    ],
    specs: {
      Material: "Algodão cru bege claro (opção: microfibra)",
      Tamanhos: "35 × 45 cm",
      Cores: "Algodão cru bege · Azul marinho (microfibra)",
      Personalização: "Silk Screen, Transfer Digital, DTF",
      "Pedido mínimo": "50 unidades",
      Prazo: "10 a 15 dias úteis",
    },
    badge: "Ecológica",
    image: PRODUCT_IMAGES.mochilaEcoAlgodao,
    gallery: [
      { src: PRODUCT_IMAGES.mochilaEcoMicrofibraAstra, label: "Microfibra branca — aplicação real com Transfer Digital colorido" },
      { src: PRODUCT_IMAGES.mochilaEcoMicrofibra, label: "Microfibra azul marinho — Sacola Tipo Mochila" },
    ],
  },
  {
    slug: "saquinho-algodao-cru",
    name: "Saquinho em Algodão Cru",
    short: "Personalizado",
    tagline: "Embalagem ecológica versátil para presentes, kits e produtos personalizados.",
    description:
      "Saquinho em algodão cru com fechamento em cordão, ideal para embalagem de brindes, presentes corporativos, kits de boas-vindas e produtos delicados. Personalização por Silk Screen, Transfer Digital ou DTF.",
    benefits: [
      "Algodão cru 100% natural",
      "Fechamento em cordão duplo",
      "Embalagem ecológica e reutilizável",
      "Personalização por Silk Screen, Transfer Digital e DTF",
    ],
    specs: {
      Material: "Algodão cru natural",
      Tamanhos: "15 × 20 cm / 20 × 30 cm / 30 × 40 cm",
      Personalização: "Silk Screen, Transfer Digital, DTF",
      "Pedido mínimo": "50 unidades",
      Prazo: "7 a 12 dias úteis",
    },
    badge: "Embalagem",
    image: PRODUCT_IMAGES.saquinhoAlgodao,
    gallery: [
      { src: PRODUCT_IMAGES.saquinhoAlgodao2, label: "Vista alternativa — Saquinho em Algodão Cru" },
    ],
  },
  {
    slug: "caneca-personalizada",
    name: "Caneca Personalizada",
    short: "Cerâmica Premium",
    tagline: "Brindes clássicos e atemporais — a caneca certa fala pela sua marca todos os dias.",
    description:
      "Caneca de cerâmica premium branca com acabamento brilhante e capacidade de 325 ml. Personalização por Transfer Digital com cores vibrantes e alta durabilidade. Ideal para brindes corporativos, ações de endomarketing e presentes executivos.",
    benefits: [
      "Cerâmica premium branca",
      "Capacidade 325 ml",
      "Personalização por Transfer Digital de alta definição",
      "Ideal para brindes e kits corporativos",
    ],
    specs: {
      Material: "Cerâmica esmaltada",
      Capacidade: "325 ml",
      Personalização: "Transfer Digital",
      "Pedido mínimo": "50 unidades",
      Prazo: "10 a 15 dias úteis",
    },
    badge: "Clássica",
    image: PRODUCT_IMAGES.canecaPersonalizada,
    gallery: [
      { src: PRODUCT_IMAGES.canecaPreta, label: "Preta matte — Caneca Personalizada 325 ml" },
      { src: PRODUCT_IMAGES.canecaAzul, label: "Azul royal — Caneca Personalizada 325 ml" },
      { src: PRODUCT_IMAGES.canecaVermelha, label: "Vermelha — Caneca Personalizada 325 ml" },
    ],
  },
  {
    slug: "dtf-textil",
    name: "DTF Têxtil Personalizado",
    short: "Impressão Têxtil",
    tagline: "Impressões DTF Têxtil de alta definição para camisetas, moletons, uniformes e brindes.",
    description:
      "Produzimos impressões em DTF Têxtil de alta definição para aplicação em camisetas, moletons, ecobags, uniformes, brindes promocionais e diversos produtos têxteis. Ideal para pequenas e grandes quantidades, com excelente durabilidade e fidelidade de cores.",
    benefits: [
      "Alta definição fotográfica",
      "Cores vibrantes e duráveis",
      "Aplicação em diversos tecidos",
      "Ideal para pequenas e grandes tiragens",
    ],
    specs: {
      Tipo: "Impressão têxtil DTF (Direct to Film)",
      Aplicação: "Camisetas, moletons, sacolas, uniformes, bonés",
      Cores: "Full color CMYK + branco",
      "Pedido mínimo": "Sob consulta",
      Prazo: "5 a 10 dias úteis",
    },
    badge: "Serviço",
    image: PRODUCT_IMAGES.dtfTextil,
    gallery: [
      { src: PRODUCT_IMAGES.dtfMoletom, label: "Aplicação em Moletom — DTF Têxtil colorido" },
      { src: PRODUCT_IMAGES.dtfBone, label: "Aplicação em Boné — DTF Têxtil colorido" },
      { src: PRODUCT_IMAGES.dtfSacola, label: "Aplicação em Sacola — DTF Têxtil colorido" },
    ],
  },
  {
    slug: "transfer-digital",
    name: "Transfer Digital Personalizado",
    short: "Impressão Digital",
    tagline: "Transfer digital de qualidade profissional com acabamento vibrante para todos os tipos de material.",
    description:
      "Fabricamos Transfer Digital personalizado com alta qualidade para aplicação em diversos materiais, proporcionando excelente definição, cores vibrantes e acabamento profissional. Solução versátil para peças únicas, séries pequenas ou grandes lotes.",
    benefits: [
      "Excelente definição de imagem",
      "Cores vibrantes e fiéis",
      "Acabamento profissional",
      "Versátil — se aplica em vários materiais",
    ],
    specs: {
      Tipo: "Transfer digital termocolante",
      Aplicação: "Tecidos, sacolas, brindes têxteis diversos",
      Cores: "Full color CMYK",
      "Pedido mínimo": "Sob consulta",
      Prazo: "5 a 10 dias úteis",
    },
    badge: "Serviço",
    image: PRODUCT_IMAGES.transferDigital,
    gallery: [
      { src: PRODUCT_IMAGES.transferCamiseta, label: "Aplicação em Camiseta — Transfer Digital colorido" },
      { src: PRODUCT_IMAGES.transferFilm, label: "Filme Transfer Digital — Detalhe macro" },
      { src: PRODUCT_IMAGES.transferMulti, label: "Múltiplas artes Transfer Digital" },
    ],
  },
  {
    slug: "camiseta-polo-masculina",
    name: "Camiseta Polo Masculina",
    short: "Personalizada",
    tagline: "Polo de tecido premium para uniformes, eventos e ações promocionais com sua marca em destaque.",
    description:
      "Camiseta polo confeccionada com tecido de alta qualidade, ideal para empresas, eventos, uniformes, ações promocionais e brindes corporativos. Personalização disponível com Silk Screen, DTF Têxtil, Bordado ou Transfer Digital.",
    category: "Vestuário Personalizado",
    keywords: [
      "camiseta polo personalizada",
      "polo masculina",
      "uniforme empresarial",
      "polo bordada",
      "polo corporativa",
      "polo silk screen",
      "polo dtf",
      "polo transfer digital",
    ],
    benefits: [
      "Alta durabilidade",
      "Excelente acabamento",
      "Diversas cores",
      "Diversos tamanhos",
      "Produção sob encomenda",
    ],
    applications:
      "Empresas, Feiras, Eventos, Uniformes, Academias, Escolas, Igrejas e ações promocionais",
    specs: {
      Material: "Piquet ou malha PV — alta qualidade",
      Personalização: "Silk Screen, DTF Têxtil, Bordado ou Transfer Digital",
      Cores: "Preta, branca, azul marinho e sob encomenda",
      Tamanhos: "P · M · G · GG · XG",
      "Pedido mínimo": "50 unidades",
      Prazo: "10 a 15 dias úteis",
    },
    badge: "Novidade",
    image: PRODUCT_IMAGES.poloPreta,
    gallery: [
      { src: PRODUCT_IMAGES.poloPreta, label: "Preta — Polo Masculina Personalizada" },
      { src: PRODUCT_IMAGES.poloBranca, label: "Branca — Polo Masculina Personalizada" },
      { src: PRODUCT_IMAGES.poloAzulMarinho, label: "Azul marinho — Polo Masculina Personalizada" },
    ],
  },
  {
    slug: "porta-copo-couro-sintetico",
    name: "Porta Copo em Couro Sintético Ecológico",
    short: "Personalizado",
    tagline: "Elegante porta copo em couro sintético ecológico para bares, restaurantes, hotéis e ações de marca.",
    description:
      "Porta copo produzido em couro sintético ecológico de alta qualidade, resistente, elegante e ideal para divulgação de marcas, bares, restaurantes, eventos, hotéis e empresas.",
    category: "Brindes Personalizados",
    keywords: [
      "porta copo personalizado",
      "porta copo em couro sintetico",
      "porta copo couro ecologico",
      "porta copo brinde",
      "porta copo empresa",
      "porta copo restaurante",
      "porta copo bar",
      "porta copo hotel",
    ],
    benefits: [
      "Material premium",
      "Couro sintético ecológico",
      "Alta resistência",
      "Fácil limpeza",
      "Personalização em alta definição",
    ],
    applications:
      "Restaurantes, Hotéis, Bares, Eventos Corporativos, Empresas, Cafeterias e Brindes Promocionais",
    specs: {
      Material: "Couro sintético ecológico premium",
      Personalização: "Gravação a laser ou hot-stamping",
      Formato: "Redondo Ø 9,5 cm (outros formatos sob consulta)",
      Cores: "Marrom, preto, caramelo e sob encomenda",
      "Pedido mínimo": "100 unidades",
      Prazo: "10 a 15 dias úteis",
    },
    badge: "Novidade",
    image: PRODUCT_IMAGES.portaCopoMnaief,
    gallery: [
      { src: PRODUCT_IMAGES.portaCopoMnaief, label: "M NAIEF — Porta copo em couro sintético (gravação a laser)" },
      { src: PRODUCT_IMAGES.portaCopoNexway, label: "Imediato Nexway — Porta copo institucional gravado" },
    ],
  },
];
